module.exports = __webpack_public_path__ + "static/sport/regiserbtn.d4db47c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/regiserbtn.png
// module id = lN+J
// module chunks = 0